import { render } from "./MediaGallery.vue?vue&type=template&id=218ad71e&scoped=true"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"

import "./MediaGallery.vue?vue&type=style&index=0&id=218ad71e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218ad71e"]])

export default __exports__